<template>
  <div class="gmf-multi-select">
    <label v-for="option in options" :key="option.value" @mousedown.stop @mouseup.stop @click.stop :class="{
      'gmf-selected': selectionMap[option.value],
    }">
      <Checkbox :modelValue="selectionMap[option.value]" @update:modelValue="v => set(option.value, v)" />
      <span v-text="option.label"></span>
    </label>
  </div>
</template>

<style>
.gmf-multi-select {
  color: var(--gmf-col-nearblack);
  background: var(--gmf-col-white);
  border-radius: var(--gmf-rounding);
  display: inline-block;
  position: relative;
  width: 100%;
}
.gmf-multi-select .gmf-checkbox {
  flex-shrink: 0;
}
.gmf-multi-select label {
  padding: var(--gmf-p-4);
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 0;

  border-radius: var(--gmf-rounding);
  background: var(--gmf-input-bg);

  display: flex;
  gap: var(--gmf-p-4);
  align-items: center;

  margin-bottom: var(--gmf-p-3);

  box-sizing: border-box;

  user-select: none;
}
.gmf-multi-select label:last-child {
  border-bottom: none;
  margin-bottom: 0;
}
.gmf-multi-select label.gmf-selected {
  background: var(--gmf-col-gray);
}
</style>

<script>
import Checkbox from '@/components/Checkbox';

export default {
  props: ['options', 'modelValue'],
  components: {
    Checkbox,
  },
  computed: {
    selectionMap () {
      const map = {};
      if (! Array.isArray(this.modelValue)) {
        if (! this.modelValue) {
          return map;
        }
        map[this.modelValue] = true;
        return map;
      }
      for (const value of this.modelValue) {
        map[value] = true;
      }
      return map;
    },
  },
  methods: {
    set (value, isSet) {
      const map = this.selectionMap;
      map[value] = isSet;
      const newValue = [];
      for (const valueOpt in map) {
        if (map[valueOpt]) {
          newValue.push(valueOpt);
        }
      }
      this.$emit('update:modelValue', newValue);
    },
  },
}
</script>
